module.exports = __webpack_public_path__ + "img/orbital.97060ff0.svg";